export interface PaymentQrData {
  iban: string
  amount: number
  variableSymbol: string
  constantSymbol: string
  bic?: string
}

const IBAN_PATTERN = /^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/
const BIC_PATTERN = /^[A-Z0-9]{8}([A-Z0-9]{3})?$/
const PAYMENT_SYMBOL_PATTERN = /^\d{1,10}$/
const MAX_AMOUNT = 9999999.99

export const getPaymentQrDataFromSubmission = (submission: any): PaymentQrData[] => {
  const payment = submission?.data?.platba
  const paymentArea = payment?.oblast

  if (!payment || !paymentArea) return []

  const variableSymbols = payment.variabilniSymboly
    ? Object.values(payment.variabilniSymboly).map((item: any) => item?.variabilniSymbol)
    : [payment.variabilniSymbol]

  return variableSymbols
    .filter((variableSymbol): variableSymbol is string | number => variableSymbol !== undefined && variableSymbol !== null)
    .map((variableSymbol) => ({
      iban: String(paymentArea.iban ?? ''),
      amount: Number(payment.celkovaCenaPlateb),
      variableSymbol: String(variableSymbol),
      constantSymbol: String(paymentArea.konsymbol ?? ''),
    }))
}

export const createSpaydString = ({
  iban,
  amount,
  variableSymbol,
  constantSymbol,
  bic = 'CNBACZPP',
}: PaymentQrData) => {
  const normalizedIban = iban.replace(/\s/g, '').toUpperCase()
  const normalizedBic = bic.replace(/\s/g, '').toUpperCase()

  if (!IBAN_PATTERN.test(normalizedIban)) {
    throw new Error('Neplatný IBAN pro QR platbu')
  }
  if (!BIC_PATTERN.test(normalizedBic)) {
    throw new Error('Neplatný BIC pro QR platbu')
  }
  if (!Number.isFinite(amount) || amount <= 0 || amount > MAX_AMOUNT) {
    throw new Error('Neplatná částka pro QR platbu')
  }
  if (!PAYMENT_SYMBOL_PATTERN.test(variableSymbol)) {
    throw new Error('Neplatný variabilní symbol pro QR platbu')
  }
  if (!PAYMENT_SYMBOL_PATTERN.test(constantSymbol)) {
    throw new Error('Neplatný konstantní symbol pro QR platbu')
  }

  return [
    'SPD',
    '1.0',
    `ACC:${normalizedIban}+${normalizedBic}`,
    `AM:${amount.toFixed(2)}`,
    'CC:CZK',
    `X-VS:${variableSymbol}`,
    `X-KS:${constantSymbol}`,
  ].join('*')
}
